import { EntityId } from '@reduxjs/toolkit';
import { ROUTER_API } from 'app/constants/api.constant';
import { UpsertedCrmFieldsDTO } from 'app/main/pages/clients/type';
import BaseApi from 'app/services/api/base.api';
import {
  ConnectCrmConnectorDTO,
  CrmConnectorAccountDTO,
  CrmConnectorTestResultDTO,
  CrmFieldMappingDTO,
  CrmInDTO,
  CrmOutDTO,
  CrmStoreMappingDTO,
  TestCrmConnectorDTO,
  UpdateClientCrmFieldDTO,
} from '../types';

export const crmApi = new BaseApi({
  baseURL: ROUTER_API,
  tokenKey: 'token',
  timeout: 20000,
});

export const getFranchiseCrmFieldsApi = async (franchiseId: EntityId, includeArchived: boolean) => {
  const response = await crmApi.api.get<CrmInDTO>(`/api/v2/franchises/${franchiseId}/crm-form`, {
    params: { includeArchived },
  });
  return response;
};

export const getFranchiseCrmFieldValuesApi = async (franchiseId: EntityId, fieldId: string) => {
  const response = await crmApi.api.get<string[]>(`/api/v2/franchises/${franchiseId}/crm-fields/${fieldId}/values`);
  return response;
};

export const saveCrmFieldsApi = async (franchiseId: EntityId, crm: CrmOutDTO) => {
  const response = await crmApi.api.post<CrmInDTO>(`/api/v2/franchises/${franchiseId}/crm-form`, crm);
  return response;
};

export const getCrmConnectorsApi = async (franchiseId: EntityId) => {
  const response = await crmApi.api.get<CrmConnectorAccountDTO[]>(`/api/v2/franchises/${franchiseId}/crm-connectors`);
  return response;
};

export const testCrmConnectorApi = async (payload: TestCrmConnectorDTO) => {
  const response = await crmApi.api.post<CrmConnectorTestResultDTO>('/services/v2/crm-connectors/test', payload);
  return response;
};

export const connectCrmConnectorApi = async (franchiseId: EntityId, payload: ConnectCrmConnectorDTO) => {
  const response = await crmApi.api.post<CrmConnectorAccountDTO>(
    `/api/v2/franchises/${franchiseId}/crm-connectors`,
    payload,
  );
  return response;
};

export const updateCrmConnectorMappingApi = async (
  franchiseId: EntityId,
  accountId: string,
  fieldMapping: CrmFieldMappingDTO[],
) => {
  const response = await crmApi.api.put<CrmConnectorAccountDTO>(
    `/api/v2/franchises/${franchiseId}/crm-connectors/${accountId}/mapping`,
    { fieldMapping },
  );
  return response;
};

export const updateCrmConnectorStoreMappingApi = async (
  franchiseId: EntityId,
  accountId: string,
  storeMapping: CrmStoreMappingDTO[],
) => {
  const response = await crmApi.api.put<CrmConnectorAccountDTO>(
    `/api/v2/franchises/${franchiseId}/crm-connectors/${accountId}/store-mapping`,
    { storeMapping },
  );
  return response;
};

export const disconnectCrmConnectorApi = async (franchiseId: EntityId, accountId: string) => {
  const response = await crmApi.api.delete<CrmConnectorAccountDTO>(
    `/api/v2/franchises/${franchiseId}/crm-connectors/${accountId}`,
  );
  return response;
};

export const updateClientCrmFieldsApi = async (
  franchiseId: string,
  storeId: string,
  userId: string,
  crmFields: UpdateClientCrmFieldDTO[],
) => {
  const response = await crmApi.api.patch<UpsertedCrmFieldsDTO>(
    `/api/v2/franchises/${franchiseId}/clients/${userId}/crm-fields`,
    crmFields,
    {
      params: { storeId },
    },
  );
  return response;
};
